export default __webpack_public_path__ + "static/media/rare-circle.ecfb183f.svg";